import { AdminArenaRow, ArenaSubscriptionStatus } from 'modules/admin/dashboard/types';
import { Card } from 'shared/components/ui/Card';
import { Badge } from 'shared/components/ui/Badge';

const STATUS_TONE: Record<ArenaSubscriptionStatus, 'success' | 'warning' | 'danger'> = {
  ativa: 'success',
  trial: 'warning',
  inadimplente: 'danger',
};

const STATUS_LABEL: Record<ArenaSubscriptionStatus, string> = {
  ativa: 'Ativa',
  trial: 'Trial',
  inadimplente: 'Inadimplente',
};

interface ArenasTableProps {
  arenas: AdminArenaRow[];
}

export function ArenasTable({ arenas }: ArenasTableProps) {
  return (
    <Card className="p-0">
      <div className="flex items-center justify-between p-5 pb-0">
        <h3 className="font-heading font-semibold text-ink">Arenas cadastradas</h3>
        <Badge tone="accent">{arenas.length} arenas</Badge>
      </div>

      <div className="mt-4 overflow-x-auto">
        <table className="w-full min-w-[560px] text-sm">
          <thead>
            <tr className="border-t border-border/70 text-left text-xs uppercase tracking-wide text-ink-secondary">
              <th className="px-5 py-2 font-medium">Arena</th>
              <th className="px-5 py-2 font-medium">Cidade</th>
              <th className="px-5 py-2 font-medium">Unidades</th>
              <th className="px-5 py-2 font-medium">Assinatura</th>
              <th className="px-5 py-2 font-medium">Desde</th>
            </tr>
          </thead>
          <tbody>
            {arenas.map((arena) => (
              <tr key={arena.id} className="border-t border-border/70">
                <td className="px-5 py-3 font-medium text-ink">{arena.name}</td>
                <td className="px-5 py-3 text-ink-secondary">{arena.city}</td>
                <td className="px-5 py-3 text-ink-secondary">{arena.units}</td>
                <td className="px-5 py-3">
                  <Badge tone={STATUS_TONE[arena.status]}>{STATUS_LABEL[arena.status]}</Badge>
                </td>
                <td className="px-5 py-3 text-ink-secondary">{arena.joinedLabel}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
